import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";
import useSmoothScroll from "@/hooks/useSmoothScroll";
import { api } from "@/lib/api";

export default function PublicLayout() {
  const [cms, setCms] = useState(null);
  const loc = useLocation();
  useSmoothScroll();
  useEffect(() => {
    api.get("/public/cms").then((r) => setCms(r.data)).catch(() => {});
  }, []);
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [loc.pathname]);

  return (
    <div className="min-h-screen bg-cream-100 text-ink-700">
      <PublicHeader />
      <main><Outlet context={{ cms }} /></main>
      <PublicFooter cms={cms} />
    </div>
  );
}
